import React from 'react'
import { Link } from 'react-router'
import {  Col, Button, Progress, Table} from 'reactstrap';

import { toLocaleDateString } from '../../../utils/date'
import Valid from 'react-icons/lib/md/check'
import NoValid from 'react-icons/lib/md/clear'


class ProfileStatus extends React.Component {

	constructor(props) {
	  super(props);

	  this.state = {};
	}

	renderProvider(){
		const { provider } = this.props

		if(this.props.responsive){
			return(
				<div className="provider-status resp-status">
						Dossier complété à : {provider.percentage} %
				</div>
			)
		}else{
			var color = 'success'
			if(provider.status == "W")
				color = 'warning'
			if(provider.sttus == "R")
				color = 'danger'

			return(
				<div>
	              <div className="progress_bar_bloc"> <Progress color={color} value={provider.percentage} /> </div>
	              <div className="last_update"> (Dernière mise à jour le {toLocaleDateString(provider.updated_at)}) </div>
	              <div className="percentageProfile"> Dossier complété à <span> {provider.percentage}%</span> </div>
	           </div>
			)
		}
	}


	renderManager(){
		const { provider } = this.props


		if(this.props.responsive){
			var status = "Candidature"
			if(provider.status == "W")
				status = 'Stand By'
			if(provider.status == "R")
				status = 'Refusé'
			if(provider.status == "PA")
				status = "Pré Analyse"
			if(provider.status == "RV")
				status = "Rendez-vous"
			if(provider.status == "RV" && provider.rdv)
				status = "Validation Finale"
			if(provider.status == "A")
				status = "Approuvé"

			return(
				<div className="provider-status resp-status">
					Etape : {status}
				</div>
			)

		}else{


			var color = 'success'
			var status = 1
			if(provider.status == "W")
				color = 'warning'
			if(provider.status == "R")
				color = 'danger'

			if(provider.status == "PA")
				status = 40
			if(provider.status == "RV")
				status = 70

			if(provider.status == "RV" && provider.rdv)
				status = 90

			if(provider.status == "A")
				status = 100

			return(
				<div className="provider-status provider-status-desktop">
	              <div className="">

	              		<Progress color={color} value={status} />

	              </div>
	              <div className="percentageProfile">
	                <Table>
	                  <tbody>
		                  <tr>
		                      <td>
		                      	Candidature
		                      	{status > 1 &&
		                      		<Valid color="b3d143" /> }

		                      </td>
		                      <td>Pré-analyse
		                      	{status > 40 &&
		                      		<Valid color="b3d143" />
		                  		}
		                      </td>
		                      <td>
		                      	Rendez-vous
		                      	{provider.rdv &&
		                      		<Valid color="b3d143" />
		                  		}
		                  		{provider.status == "A" && !provider.rdv &&
		                      		<Valid color="b3d143" />
		                  		}
		                      </td>

		                      <td>
		                      	Validation finale
		                      	{provider.status == "A" &&
		                      		<Valid color="b3d143" />
		                  		}

		                      </td>
		                  </tr>
	                  </tbody>
	                </Table>
	              </div>
	          </div>
		  )
	  }
	}



	render(){
		const { user } = this.props

		return(
			<Col xs="12" sm="6">
				{user.role == "provider" &&
					this.renderProvider()
				||
					this.renderManager()
				}
			</Col>
		)
	}
}

export default ProfileStatus



// WEBPACK FOOTER //
// ./src/provider/components/profile/ProfileStatus.js